import { use } from 'react';
import { ModalContext } from '@/common/components/modal-provider/ModalContext';

export const useModal = () => {
  const context = use(ModalContext);
  return context.showModal;
};
